module.exports = __webpack_public_path__ + "img/132ne.70eda631.svg";